import { NavLink } from 'react-router-dom';
import React from 'react';
import styles from '../../main-nav/MainNav.module.scss';

const MenuNavLink = (props) => {
  return <NavLink exact={true} {...props} activeClassName="active" className={styles.active} />;
  // return <NavLink exact={true} {...props} activeClassName="active" className={styles.mainContainer__navLink} />;
};

export default MenuNavLink;
